<template>
  <section class="py-12">
    <div class="container-wrap">
      <div class="mb-6 tablet:mb-0 tablet:flex tablet:items-center">
        <div class="tablet:w-1/2 tablet:pr-2 desktop:pr-3">
          <h2 class="mb-6 text-2xl font-bold desktop:text-3xl">
            {{ contextData.title }}
          </h2>
          <p class="mb-6 w-full text-gray-600">
            {{ contextData.description1 }}
          </p>
          <p class="mb-6 w-full text-gray-600">
            {{ contextData.description2 }}
          </p>
        </div>
        <div class="tablet:w-1/2 tablet:pl-2 desktop:pl-3">
          <figure class="relative aspect-video w-full overflow-hidden">
            <img
              :src="`${blobDomain}/wise-paas-marketplace/pages/home/sections/section1/overview.webp`"
              :alt="contextData.title"
              loading="lazy"
              class="pointer-events-none absolute left-0 top-0 h-full w-full object-cover"
            />
          </figure>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import EN_AMERICAS_JSON from '@/assets/data/home/en-americas/section-1-1.json';
  import EN_ASIA_PACIFIC_JSON from '@/assets/data/home/en-asia-pacific/section-1-1.json';
  import EN_EMEA_JSON from '@/assets/data/home/en-emea/section-1-1.json';
  import EN_INT_JSON from '@/assets/data/home/en-int/section-1-1.json';
  import EN_JP_JSON from '@/assets/data/home/en-jp/section-1-1.json';
  import EN_KR_JSON from '@/assets/data/home/en-kr/section-1-1.json';
  import EN_TW_JSON from '@/assets/data/home/en-tw/section-1-1.json';
  import JA_JP_JSON from '@/assets/data/home/ja-jp/section-1-1.json';
  import ZH_TW_JSON from '@/assets/data/home/zh-tw/section-1-1.json';

  interface IOverviewData {
    title: string;
    description1: string;
    description2: string;
  }

  const { locale } = useI18n();
  const { blobDomain } = useWebsite();

  const contextData = computed((): IOverviewData => {
    switch (locale.value) {
      case EnumLocale.EN_INT:
        return EN_INT_JSON;
      case EnumLocale.EN_AMERICAS:
        return EN_AMERICAS_JSON;
      case EnumLocale.EN_JP:
        return EN_JP_JSON;
      case EnumLocale.EN_TW:
        return EN_TW_JSON;
      case EnumLocale.EN_KR:
        return EN_KR_JSON;
      case EnumLocale.EN_ASIA_PACIFIC:
        return EN_ASIA_PACIFIC_JSON;
      case EnumLocale.EN_EMEA:
        return EN_EMEA_JSON;
      case EnumLocale.ZH_TW:
        return ZH_TW_JSON;
      case EnumLocale.JA_JP:
        return JA_JP_JSON;
      default:
        return EN_INT_JSON;
    }
  });
</script>
